require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-the-world-banks-new-gender-strategy-be-strengthened.json") })
        }
      }, "path---en-us-update-how-can-the-world-banks-new-gender-strategy-be-strengthened");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-the-world-banks-new-gender-strategy-be-strengthened!./.cache/json/en-us-update-how-can-the-world-banks-new-gender-strategy-be-strengthened.json
// module id = 728
// module chunks = 231608221292675